module.exports = __webpack_public_path__ + "img/PDM-600-Mobile.b4a5f2e5a4c76ac936461ad6be420d9c.avif";